import React, { useContext } from "react";
import styled from 'styled-components'
import { Context } from "../context"
import CartGif from "../../images/cart.gif"

const BtnCart = styled.span`
    position:relative;
    .count{
      position: absolute;
      top: -10px;
      right: 0px;
      background-color: #fff;
      border-radius: 50%;
      color: #E9242A;
      font-size: 12px;
      line-height: 24px;
      font-weight: 700;
      width: 20px;
      height: 20px;
      text-align: center;
      display: flex;
      justify-content: center;
      z-index: 1;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.3);
    }
`;

const CartButton = () => {
  const { cartData } = useContext(Context);
  
  return (
    <BtnCart>
      <span className="count">{cartData?.length || 0}</span>
      <span className="btn btn-white btn-sm">
        <span className="icon"><img src={CartGif} alt="EMB Metal Buildings" /></span>
      </span>
    </BtnCart>
  )
}
export default CartButton;